/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IGetOnboardingJourneyQuery,
  IGetOnboardingJourneyQueryVariables,
  GetOnboardingJourneyDocument,
} from './types';
import { IUserOnboardingJourney } from '@r-client/data/graphql-types';
export type { IUserOnboardingJourney };

export type IGetOnboardingJourneyQueryOpts =
  IQueryModelOpts<IGetOnboardingJourneyQueryVariables>;

export class GetOnboardingJourneyQuery extends BaseQueryModel<
  IGetOnboardingJourneyQuery,
  IGetOnboardingJourneyQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IGetOnboardingJourneyQueryOpts) {
    super(opts);
  }

  get query() {
    return GetOnboardingJourneyDocument;
  }
}
export function useGetOnboardingJourneyQuery(
  opts?: Omit<IGetOnboardingJourneyQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new GetOnboardingJourneyQuery({ ...opts, client }),
    opts?.variables
  );
}
